import { useMemo } from 'react';

import { WalletCard, useListBackerConsumerWallet } from '@givebacks/api/backer';
import { NoDataMessageCard, Skeleton, Stack } from 'ui';

import { ConsumerWalletListCard } from '../ConsumerWalletCard/ConsumerWalletListCard';
import classes from './AccountCardList.module.css';

type AccountCardListProps = {
  filterFn: (data: WalletCard[]) => WalletCard[];
  getKey: (card: WalletCard) => string | undefined;
  noDataTitle: string;
  noDataMessage: string;
};

const AccountCardList = ({
  filterFn,
  getKey,
  noDataTitle,
  noDataMessage,
}: AccountCardListProps) => {
  const { data: backerWalletCards, isLoading } = useListBackerConsumerWallet({
    select: filterFn,
  });

  const isEmpty = useMemo(() => {
    return backerWalletCards?.length === 0 && !isLoading;
  }, [backerWalletCards, isLoading]);

  if (isEmpty && !isLoading) {
    return <NoDataMessageCard title={noDataTitle} message={noDataMessage} />;
  }

  return (
    <Skeleton height={72} visible={isLoading}>
      <Stack className={classes.AccountCardList}>
        {backerWalletCards?.map((card) => (
          <ConsumerWalletListCard walletCard={card} key={getKey(card)} />
        ))}
      </Stack>
    </Skeleton>
  );
};

export { AccountCardList };
